import { createContext, useContext, useState } from "react";
import { tournamentAPI } from "../services/api";

export const TournamentContext = createContext();

export const TournamentProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    sortBy: "",
    status: "",
    format: "",
    search: "",
    sortOrder: "",
    type: "",
    game: "",
  });

  const updateFilters = (newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  };

  // -------- Load Tournaments --------
  const loadTournaments = async (params = {}) => {
    try {
      const queryParams = {
        sortBy: filters.sortBy,
        search: filters.search,
        status: filters.status,
        format: filters.format,
        sortOrder: filters.sortOrder,
        game: filters.game,
        type: filters.type,
        ...params,
      };
      const response = await tournamentAPI.loadTournaments(queryParams);
      return response;
    } catch (error) {}
  };

  // --------- Load Tournament ---------
  const loadTournament = async (tournamentId) => {
    try {
      const response = await tournamentAPI.loadTournament(tournamentId);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // --------- Update Stream Link In TournamentParticiapnts Model --------
  const updateStreamLink = async (data) => {
    try {
      const response = tournamentAPI.updateStreamLink(data);
      return response;
    } catch (error) {
      console.log("Update stream link error", error);
      throw error;
    }
  };

  const loadPlayerInTournament = async (params = {}) => {
    try {
      const response = await tournamentAPI.loadPlayerInTournament(params);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ---------- Load Games ------------
  const loadGames = async (query) => {
    try {
      const response = await tournamentAPI.loadGames(query);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ---------- Load Game List ----------
  const gamesList = async (status) => {
    try {
      const response = await tournamentAPI.gamesList(status);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // --------- Seasons List -------------
  const seasonsList = async (id) => {
    try {
      const response = await tournamentAPI.seasonsList(id);
      return response;
    } catch (error) {
      return error;
    }
  };

  // --------- Geners List --------------
  const genersList = async (status) => {
    try {
      const response = await tournamentAPI.genersList(status);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ------- Register Tournaments -------
  const registerTournament = async (tournamentData) => {
    try {
      const response = await tournamentAPI.registerTournament(tournamentData);
      return response;
    } catch (error) {
      console.log("resigter tournament context error", error);
      throw error;
    }
  };

  // ------- Create Private Tournaments -------
  const createPrivateTournament = async (data) => {
    try {
      const response = await tournamentAPI.createPrivateTournament(data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ------ Load Tournament Teams ------
  const loadTournamentList = async (query) => {
    try {
      const response = await tournamentAPI.loadTournamentList(query);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ------- Create Team ---------
  const joinTeam = async (teamData) => {
    try {
      const response = await tournamentAPI.joinTeam(teamData);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // -------- Join With Team --------
  const joinWithTeam = async (teamData) => {
    try {
      const response = await tournamentAPI.joinWithTeam(teamData);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ------- View Brackets -------
  const viewBrackets = async (tournamentId) => {
    try {
      const response = await tournamentAPI.viewBrackets(tournamentId);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ------- Load Teams -------
  const loadTeams = async (tournamentId) => {
    try {
      const response = await tournamentAPI.loadTeams(tournamentId);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ------- Switch Players --------
  const switchPlayers = async (data) => {
    try {
      const response = await tournamentAPI.switchPlayers(data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ------- Update Team --------
  const updateTeam = async (data) => {
    try {
      const response = await tournamentAPI.updateTeam(data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ------ Generate Tournament -------
  const generateBracket = async (tournamentId) => {
    try {
      const response = await tournamentAPI.generateBracket(tournamentId);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ------ Generate Tournament -------
  const updateTeamScore = async (data) => {
    try {
      const response = await tournamentAPI.updateTeamScore(data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  // ---------- Progress to next round --------
  const progressToNextRound = async (tournamentId) => {
    try {
      const response = await tournamentAPI.progressToNextRound(tournamentId);
      return response;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  };

  // ---------- Final round end -----------
  const endFinalRound = async (tournamentId) => {
    try {
      const response = await tournamentAPI.endFinalRound(tournamentId);
      return response;
    } catch (error) {
      throw error;
    }
  };

  return (
    <TournamentContext.Provider
      value={{
        //-------- Actions ---------
        loadTournaments,
        loadTournament,
        updateStreamLink,
        loadGames,
        registerTournament,
        createPrivateTournament,
        loadTournamentList,
        joinTeam,
        joinWithTeam,
        loadPlayerInTournament,
        viewBrackets,
        gamesList,
        seasonsList,
        genersList,
        loadTeams,
        switchPlayers,
        updateTeam,
        generateBracket,
        updateTeamScore,
        progressToNextRound,
        endFinalRound,
        //-------- States ---------
        filters,
        //-------- Setters ---------
        setFilters,
        updateFilters,
      }}
    >
      {children}
    </TournamentContext.Provider>
  );
};

// Custom hook to use the tournament context
export const useTournament = () => {
  const context = useContext(TournamentContext);
  if (context === undefined) {
    throw new Error("useTournament must be used within a TournamentProvider");
  }
  return context;
};
